'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _defaultConfig = require('./defaultConfig');
var _defaultConfig2 = _interopRequireDefault(_defaultConfig);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = function () {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _ref => {
    let {
      addUtilities,
      config: userConfig
    } = _ref;
    const config = name => {
      return name in options ? options[name] : userConfig(name, _defaultConfig2.default[name]);
    };
    const variants = config('transitionVariants');
    const prefix = config('transitionPrefix');
    const className = function (key) {
      let modifier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return 'default' === key ? prefix : `${prefix}${modifier}-${key}`;
    };

    // Duration
    addUtilities(Object.entries(config('transitionDuration')).map(_ref2 => {
      let [key, value] = _ref2;
      return {
        [className(key)]: {
          'transition-duration': value
        }
      };
    }), variants);

    // Property
    addUtilities(Object.entries(config('transitionProperty')).map(_ref3 => {
      let [key, value] = _ref3;
      return {
        [className(key, '-property')]: {
          'transition-property': value
        }
      };
    }), variants);

    // Timing Function
    addUtilities(Object.entries(config('transitionTimingFunction')).map(_ref4 => {
      let [key, value] = _ref4;
      return {
        [className(key, '-timing')]: {
          'transition-timing-function': value
        }
      };
    }), variants);

    // Delay
    addUtilities(Object.entries(config('transitionDelay')).map(_ref5 => {
      let [key, value] = _ref5;
      return {
        [className(key, '-delay')]: {
          'transition-delay': value
        }
      };
    }), variants);
  };
};